import { render, staticRenderFns } from "./DcSubscribePremium.vue?vue&type=template&id=66b434f3&scoped=true&"
import script from "./DcSubscribePremium.vue?vue&type=script&lang=ts&"
export * from "./DcSubscribePremium.vue?vue&type=script&lang=ts&"
import style0 from "./DcSubscribePremium.vue?vue&type=style&index=0&id=66b434f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b434f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('66b434f3', component.options)
    } else {
      api.reload('66b434f3', component.options)
    }
    module.hot.accept("./DcSubscribePremium.vue?vue&type=template&id=66b434f3&scoped=true&", function () {
      api.rerender('66b434f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DcSubscribePremium.vue"
export default component.exports